/* Velomora cart: drawer open/close, add to cart, buy now, line removal,
   section re-render, count bubbles, and the "added to bag" toast. */
(function () {
  'use strict';

  var DRAWER_SECTION = 'velomora-cart-drawer';
  var busy = false;

  function drawer() {
    return document.getElementById('VmCartDrawer');
  }

  function openDrawer() {
    var el = drawer();
    if (!el) return;
    el.classList.add('is-open');
    el.setAttribute('aria-hidden', 'false');
    document.body.classList.add('vm-lock');
  }

  function closeDrawer() {
    var el = drawer();
    if (!el) return;
    el.classList.remove('is-open');
    el.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('vm-lock');
  }

  function updateCounts(count) {
    document.querySelectorAll('[data-vm-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.setAttribute('data-count', count);
    });
  }

  /* fetch() only rejects on a network failure, so a 422 (out of stock, bad
     quantity) or a 429 arrives as a resolved response and every .catch below
     misses it. Route every cart response through here instead: it throws
     Shopify's own error body, which carries a `description` worth showing. */
  function cartJson(res) {
    return res
      .json()
      .catch(function () {
        /* an HTML error page, a proxy timeout, anything not JSON */
        throw { status: res.status };
      })
      .then(function (data) {
        if (!res.ok) throw data || { status: res.status };
        return data;
      });
  }

  /* A failed *refresh* means the cart itself changed successfully and only the
     re-render broke. That needs different handling from a failed cart write, so
     tag it and let callers tell the two apart. */
  function refreshFailed(err) {
    var wrapped = err && typeof err === 'object' ? err : {};
    wrapped.vmRefreshFailed = true;
    throw wrapped;
  }

  function refreshDrawer() {
    return fetch(window.routes.cart_url + '?sections=' + DRAWER_SECTION)
      .then(cartJson)
      .then(function (sections) {
        var html = sections[DRAWER_SECTION];
        if (!html) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('.vm-drawer__panel');
        var current = drawer() && drawer().querySelector('.vm-drawer__panel');
        if (fresh && current) {
          current.innerHTML = fresh.innerHTML;
          current.setAttribute('data-vm-discount-codes', fresh.getAttribute('data-vm-discount-codes') || '');
          current.setAttribute('data-vm-drawer-count', fresh.getAttribute('data-vm-drawer-count') || '0');
        }
        var countEl = doc.querySelector('[data-vm-drawer-count]');
        if (countEl) updateCounts(countEl.getAttribute('data-vm-drawer-count'));
      })
      .catch(refreshFailed);
  }

  function toast(title, message) {
    var existing = document.querySelector('.vm-toast');
    if (existing) existing.remove();
    var el = document.createElement('div');
    el.className = 'vm-toast';
    el.setAttribute('role', 'status');
    el.innerHTML =
      '<span class="vm-toast__ic">' +
      '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
      '<path d="M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4Z"/><path d="M3 6h18"/><path d="M16 10a4 4 0 0 1-8 0"/></svg></span>' +
      '<span><div class="vm-toast__title"></div><div class="vm-toast__msg"></div></span>';
    el.querySelector('.vm-toast__title').textContent = title;
    el.querySelector('.vm-toast__msg').textContent = message;
    document.body.appendChild(el);
    clearTimeout(toast.timer);
    toast.timer = setTimeout(function () {
      el.remove();
    }, 3200);
  }

  /* Shopify puts the useful sentence in `description` ("You can only add 3 of
     this to your cart"). Show it when there is one rather than the generic
     fallback, which tells the shopper nothing about what to do next. */
  function cartErrorToast(err) {
    var strings = window.vmStrings || {};
    /* `description` only. Never err.message: on a dropped connection that is
       "Failed to fetch", which is not a sentence to show a shopper. */
    var detail = (err && err.description) || '';
    toast(strings.cartError || 'Something went wrong', detail);
  }

  function addFromForm(form) {
    var formData = new FormData(form);
    return fetch(window.routes.cart_add_url + '.js', {
      method: 'POST',
      headers: { 'X-Requested-With': 'XMLHttpRequest' },
      body: formData,
    }).then(cartJson);
  }

  /* open / close triggers */
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-vm-cart-open]')) {
      e.preventDefault();
      openDrawer();
      return;
    }
    if (e.target.closest('[data-vm-cart-close]')) {
      e.preventDefault();
      closeDrawer();
      return;
    }

    /* line item removal */
    var remove = e.target.closest('[data-vm-line-remove]');
    if (remove) {
      e.preventDefault();
      changeLine(remove.getAttribute('data-vm-line-remove'), 0);
      return;
    }

    /* line quantity steppers */
    var minus = e.target.closest('[data-vm-line-minus]');
    if (minus) {
      e.preventDefault();
      changeLine(minus.getAttribute('data-vm-line-minus'), Number(minus.getAttribute('data-qty')) - 1);
      return;
    }
    var plus = e.target.closest('[data-vm-line-plus]');
    if (plus) {
      e.preventDefault();
      changeLine(plus.getAttribute('data-vm-line-plus'), Number(plus.getAttribute('data-qty')) + 1);
      return;
    }

    /* remove an applied discount code */
    var codeRemove = e.target.closest('[data-vm-discount-remove]');
    if (codeRemove) {
      e.preventDefault();
      var keep = appliedCodes().filter(function (c) {
        return c.toUpperCase() !== codeRemove.getAttribute('data-vm-discount-remove').toUpperCase();
      });
      updateDiscounts(keep.join(','))
        .then(refreshDrawer)
        .catch(recoverFromStaleCart);
    }
  });

  /* The cart write landed but the drawer never re-rendered, so what the shopper
     is looking at is out of date. Leaving stale quantities on screen is how
     someone adds the same thing twice; send them to the cart page, which is
     rendered server-side and cannot be stale. Anything else is a real failure. */
  function recoverFromStaleCart(err) {
    if (err && err.vmRefreshFailed) {
      window.location.href = window.routes.cart_url;
      return;
    }
    cartErrorToast(err);
  }

  function changeLine(key, quantity) {
    if (busy) return;
    busy = true;
    fetch(window.routes.cart_change_url + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ id: key, quantity: Math.max(0, quantity) }),
    })
      .then(cartJson)
      .then(refreshDrawer)
      .catch(recoverFromStaleCart)
      .finally(function () {
        busy = false;
      });
  }

  function appliedCodes() {
    var panel = drawer() && drawer().querySelector('.vm-drawer__panel');
    var raw = panel ? panel.getAttribute('data-vm-discount-codes') : '';
    return (raw || '').split(',').filter(Boolean);
  }

  /* Resolves with the cart, or with null when another cart call is already in
     flight and this one was skipped. Callers must treat null as "nothing
     happened": a skipped call used to resolve as undefined, which read as "the
     code did not apply" and triggered a pointless rollback. */
  function updateDiscounts(codesString) {
    if (busy) return Promise.resolve(null);
    busy = true;
    return fetch(window.routes.cart_update_url + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ discount: codesString }),
    })
      .then(cartJson)
      .finally(function () {
        busy = false;
      });
  }

  /* apply a discount code */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-vm-discount-form]');
    if (!form) return;
    e.preventDefault();
    if (busy) return;
    var input = form.querySelector('[data-vm-discount-input]');
    var error = drawer() && drawer().querySelector('[data-vm-discount-error]');
    var code = (input.value || '').trim();
    if (!code) return;

    /* busy state until the drawer re-renders */
    var applyBtn = form.querySelector('button[type="submit"]');
    if (applyBtn) {
      applyBtn.vmPrevHtml = applyBtn.innerHTML;
      applyBtn.disabled = true;
      applyBtn.innerHTML = '<span class="vm-spinner" aria-hidden="true"></span>';
    }
    input.readOnly = true;
    var previous = appliedCodes();
    var next = previous
      .filter(function (c) {
        return c.toUpperCase() !== code.toUpperCase();
      })
      .concat(code);

    function releaseForm() {
      if (applyBtn) {
        applyBtn.disabled = false;
        applyBtn.innerHTML = applyBtn.vmPrevHtml || applyBtn.innerHTML;
      }
      input.readOnly = false;
    }

    updateDiscounts(next.join(','))
      .then(function (cartData) {
        /* skipped because another cart call was mid-flight: nothing was sent,
           so there is nothing to roll back. Hand the form back and stop. */
        if (cartData === null) {
          releaseForm();
          return null;
        }
        var entry = (cartData.discount_codes || []).find(function (c) {
          return c.code.toUpperCase() === code.toUpperCase();
        });
        if (entry && entry.applicable) {
          return refreshDrawer();
        }
        /* roll the invalid code back out, re-render, surface the error */
        return updateDiscounts(previous.join(',')).then(function () {
          return refreshDrawer().then(function () {
            var freshError = drawer() && drawer().querySelector('[data-vm-discount-error]');
            if (freshError) freshError.hidden = false;
          });
        });
      })
      .catch(function (err) {
        /* the drawer never re-rendered, so un-stick the form either way */
        releaseForm();
        recoverFromStaleCart(err);
      });
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeDrawer();
  });

  /* instant feedback on the clicked button while the cart round-trip runs */
  function buttonBusy(btn) {
    if (!btn || btn.vmBusy) return;
    btn.vmBusy = true;
    btn.disabled = true;
    btn.vmPrevHtml = btn.innerHTML;
    btn.style.minWidth = btn.offsetWidth + 'px';
    btn.innerHTML = '<span class="vm-spinner" aria-hidden="true"></span>';
  }

  function buttonIdle(btn) {
    if (!btn || !btn.vmBusy) return;
    btn.vmBusy = false;
    btn.disabled = false;
    btn.innerHTML = btn.vmPrevHtml;
    btn.style.minWidth = '';
    btn.vmPrevHtml = null;
  }

  /* add-to-cart forms */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-vm-atc]');
    if (!form) return;
    e.preventDefault();
    if (busy) return;
    busy = true;
    var strings = window.vmStrings || {};

    /* proxy buttons (sticky bar, buy now) stash themselves on the form */
    var trigger = form.vmTriggerBtn || e.submitter || form.querySelector('[data-vm-atc-btn], button[type="submit"]');
    form.vmTriggerBtn = null;
    buttonBusy(trigger);

    addFromForm(form)
      .then(function (item) {
        if (form.hasAttribute('data-vm-redirect-checkout')) {
          window.location.href = window.routes.cart_url + '/checkout';
          return null;
        }
        return refreshDrawer().then(function () {
          var meta = item.product_title || '';
          if (item.variant_title && item.variant_title !== 'Default Title') {
            meta += ' · ' + item.variant_title;
          }
          toast(strings.addedToBag || 'Added to bag', meta);
          openDrawer();
        });
      })
      /* When only the re-render failed the item really is in the cart, so do
         not report a failure: the shopper would add it a second time. The cart
         page shows them the truth instead. */
      .catch(recoverFromStaleCart)
      .finally(function () {
        busy = false;
        buttonIdle(trigger);
      });
  });

  /* buy now: flag the form, submit through the same pipeline */
  document.addEventListener('click', function (e) {
    var buyNow = e.target.closest('[data-vm-buy-now]');
    if (!buyNow) return;
    e.preventDefault();
    var form = buyNow.closest('form') || document.getElementById(buyNow.getAttribute('data-vm-form') || '');
    if (!form) return;
    form.vmTriggerBtn = buyNow;
    form.setAttribute('data-vm-redirect-checkout', '');
    if (form.requestSubmit) form.requestSubmit();
    else form.submit();
    setTimeout(function () {
      form.removeAttribute('data-vm-redirect-checkout');
    }, 4000);
  });

  window.vmCart = {
    open: openDrawer,
    close: closeDrawer,
    /* refreshDrawer() rejects on failure and app embeds calling this rarely
       attach a handler, so absorb it here rather than emit an unhandled
       rejection from third-party code. */
    refresh: function () {
      return refreshDrawer().catch(recoverFromStaleCart);
    },
    toast: toast,
  };
})();
